import { defineComponent as _defineComponent } from 'vue'
import { offset, flip, size, shift } from '@floating-ui/vue'
import { ref } from 'vue'
import { useClipboard } from '@vueuse/core'

import LButton from '@/components/core/Button.vue'
import { useDismiss, useHover, usePopover } from '@/composables/popover'

export interface EmbedViaIframePopoverProps {
  token: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmbedViaIframePopover',
  props: {
    token: null
  },
  setup(__props: any) {

const props = __props as {
  token: string
};



const embedCode = `
<div style='position: relative;overflow: hidden;width: 100%;padding-top: 56.25%;'>
  <iframe src='https://embed.lambus.com/?tid=${props.token}' frameborder='0'style='border: 1px solid #f0f0f0;position: absolute;top: 0;left: 0;bottom: 0;right: 0;width: 100%;height: 100%;'></iframe>
</div>`

// Clipboard functionality -----------------------------------------------------

const { copied, copy } = useClipboard()

async function copyToClipboard(text: string) {
  await copy(text)
}

// Popover Functionality -------------------------------------------------------

const isOpen = ref(false)

const { referenceRef, floatingRef, floatingStyles } = usePopover({
  placement: 'bottom-start',
  isOpen,
  middleware: [
    offset(4),
    flip({ padding: 16, fallbackPlacements: ['top-start'] }),
    size({
      padding: 16,
    }),
    shift({ padding: 16, crossAxis: true }),
  ],
})
const listeners = useHover({ isOpen, openDelay: 250, closeDelay: 50 })
useDismiss({ referenceRef, floatingRef, isOpen })

return { __sfc: true,props, embedCode, copied, copy, copyToClipboard, isOpen, referenceRef, floatingRef, floatingStyles, listeners, LButton }
}

})